<template>
  <div class="prictice-container">
    <el-row :gutter="15" class="prictice-list">
      <el-col :span="6" v-for="(item, i) in pricticelist" :key="item.id">
        <div
          :class="{ 'prictice-item': 1, active: active === i }"
          @click="clickItem(i)"
        >
          <div class="title">
            <el-tooltip :content="item.title" placement="top-start">
              <span>{{ item.title }}</span>
            </el-tooltip>
          </div>
          <div class="content">
            <div class="submissionStatus">
              已提交次数：
              <el-link
                style="font-size: 12px;"
                @click="methodLookScore(item)"
                type="primary"
                >{{ item.stuExamSubmitTimes }}</el-link
              >
            </div>
            <!-- <div class="desc">
              <span>试题数量 11</span>
              <span>总分 100</span>
            </div> -->
            <div class="create-time">开始时间 {{ item.start_date }}</div>
            <div class="end-time">结束时间 {{ item.end_date }}</div>
          </div>
          <div class="detail">
            <div class="line"></div>
            <div class="management">
              <el-button
                size="mini"
                @click="methodGoPractice(item)"
                v-if="$props.stuExamTimeSearch === 1 && item.post_state === 1"
              >
                开始练习
              </el-button>
              <el-button
                size="mini"
                @click="methodLookScore(item)"
                v-if="$props.stuExamTimeSearch === 2 && item.post_state === 1"
              >
                查看练习
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'subunitPrictice',
  props: ['pricticelist', 'stuExamTimeSearch'],
  data: () => ({
    active: -1,
  }),
  methods: {
    methodLookScore(item) {
      this.$emit('methodLookScore', item)
    },
    methodGoPractice(item) {
      this.$emit('methodGoPractice', item)
    },
    clickItem(i) {
      this.active = i
    },
  },
}
</script>
<style scoped lang="scss">
.prictice-container {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .prictice-list {
    display: flex;
    flex-wrap: wrap;

    .prictice-item {
      // box-sizing: border-box;
      // width: 23.5%;
      position: relative;
      padding: 20px 15px 15px;
      margin-bottom: 20px;
      transition: box-shadow 0.2s;
      background: url('../components/img/paperIcon@2x.png') right top / 50%
        no-repeat;
      border-radius: 5px;
      background-color: #fff;
      &::before {
        position: absolute;
        left: -1px;
        top: -1px;
        width: 100%;
        height: 100%;
        content: '';
        display: block;
        border-radius: 5px;
        border: 1px solid transparent;
        transition: border-color 0.2s;
        pointer-events: none;
      }
      &:hover,
      &.active {
        box-shadow: 1px 0px 4px 0px #7591b8;
        &::before {
          border-color: #1678ff;
        }
      }
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        img {
          display: block;
          width: 50px;
          height: 50px;
          object-fit: cover;
          border-radius: 5px;
        }
        .el-button {
          height: 30px;
          background-color: #fff;
          color: #2c85ff;
          &:hover {
            color: #2c85ff;
          }
        }
      }
      .title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .content {
        padding: 15px 0px 0px;
        .desc {
          display: flex;
          align-items: center;
          padding-bottom: 10px;
          span {
            color: #2c85ff;
            &:first-child {
              margin-right: 25px;
            }
          }
        }
        .submissionStatus {
          display: inline-flex;
          align-items: center;
          padding-bottom: 8px;
        }
        .creator,
        .create-time,
        .end-time {
          padding-bottom: 5px;
          color: #666;
        }
        .statistics {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          width: 100%;
          padding: 5px 0 0;
          color: #333;
        }
        .status-operation {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .status {
            padding-top: 6px;
          }
          .operation {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            padding-top: 10px;
            min-height: 46px;
            .el-button {
              padding: 0;
              margin-left: 7px;
              margin-bottom: 5px;
              color: #2c85ff;
              &:not(:first-child) {
                border-left: 1px solid #cbcbcb;
                padding-left: 7px;
              }
            }
            span {
              display: inline-flex;
              align-items: center;
              height: 12px;
              margin-left: 7px;
              margin-bottom: 5px;
              color: #2c85ff;
              &:not(:first-child) {
                border-left: 1px solid #cbcbcb;
                padding-left: 7px;
              }

              cursor: pointer;
            }
          }
        }
        /**
        @media screen and (max-width: 1600px) {
        }
        */
      }
      .detail {
        padding: 0px 5px;
        // background: #f7f9ff;
        // box-shadow: 0px 2px 4px 0px #93abcc;
        border-radius: 5px;
        .detail-title {
          // padding-bottom: 5px;
          font-weight: 400;
          font-size: 14px;
          color: #323233;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          // text-shadow: 0px 2px 4px #93abcc;
        }
        .line {
          padding: 8px 0px;
          &::after {
            content: '';
            display: block;
            margin: 0 auto;
            border-top: 1px dashed #eaeaea;
          }
        }
        p {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          &.questionNum {
            padding-bottom: 5px;
          }
          span {
            font-size: 14px;
            color: #666;
          }
        }
        .management {
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
          .el-button {
            position: relative;
            &:not(:last-child)::after {
              content: '';
              position: absolute;
              right: -5px;
              width: 1px;
              height: 12px;
              background-color: #cbcbcb;
            }
            /deep/ span {
              display: inline-flex;
              align-items: center;
              color: #2c85ff;
            }
            img {
              height: 11px;
              margin-right: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
